<template>
  <div>
    <PCNavbar selectIndex="1-2"/>
    <MobileNavBar :currentActive="2" />
    <ServiceItem/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import ServiceItem from "@/components/service_item/index.vue";

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    ServiceItem
  },
}
</script>

<style>
</style>